import { render, staticRenderFns } from "./AnchorButton.vue?vue&type=template&id=73e284c2&"
import script from "./AnchorButton.vue?vue&type=script&lang=js&"
export * from "./AnchorButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports